export default "__VITE_ASSET__CU8d20_q__"